import { FC, useMemo } from 'react'
import { SocialIcon } from 'react-social-icons'
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  PinterestShareButton,
  PinterestIcon,
} from 'react-share'

import { StyledButtonsContainer } from './styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'

const installText = () => 'Here is where i buy products'

export const ShareButtons = () => {
  const interfaceStyles = useMySelector((state) => state.app.interfaceStyles)
  const { guid, registerId, dataEnc } = handleLocalStorage([
    'guid',
    'registerId',
    'dataEnc',
  ])

  const URL = useMemo(() => {
    return dataEnc
      ? `${process.env.REACT_APP_URL}?data=${dataEnc}`
      : guid
      ? `${process.env.REACT_APP_URL}?guid=${guid}${
          registerId ? '&register=' + registerId : ''
        }`
      : ''
  }, [dataEnc, guid, registerId])

  return (
    <StyledButtonsContainer>
      <FacebookShareButton
        key={`${URL}_fb`}
        quote={installText()}
        title={installText()}
        url={URL}
      >
        <Icon I={FacebookIcon} />
      </FacebookShareButton>
      <TwitterShareButton
        key={`${URL}_twitter`}
        title={installText()}
        url={URL}
      >
        <SocialIcon network="x" />
      </TwitterShareButton>
      <WhatsappShareButton
        key={`${URL}_whatsapp`}
        title={installText()}
        url={URL}
      >
        <Icon I={WhatsappIcon} />
      </WhatsappShareButton>
      <PinterestShareButton
        key={`${URL}_pinterest`}
        media={interfaceStyles.appIcon || interfaceStyles.logoImage}
        description={installText()}
        url={URL}
      >
        <Icon I={PinterestIcon} />
      </PinterestShareButton>
    </StyledButtonsContainer>
  )
}

const Icon: FC<any> = ({ I }) => <I round size={50} />
